(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (() => {
    const header = document.querySelector('.header');
    const dock = header?.querySelector('.header__search-dock');
    const toggle = header?.querySelector('.header__search-toggle');
    const searchContainer = header?.querySelector('.search-container');
    const searchInput = searchContainer?.querySelector('.search-input');

    if (!header || !dock || !toggle || !searchContainer) return;

    const desktopFoldoutMedia = window.matchMedia('(min-width: 990px)');

    const closeSearch = ({ restoreFocus = false, clearQuery = true } = {}) => {
      header.classList.remove('header--search-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', toggle.dataset.searchLabel);

      if (clearQuery && searchInput && searchInput.value) {
        searchInput.value = '';
        searchInput.dispatchEvent(new Event('input', { bubbles: true }));
      }

      const predictiveSearch = searchContainer.querySelector('predictive-search');
      if (typeof predictiveSearch?.close === 'function') predictiveSearch.close();
      if (restoreFocus) requestAnimationFrame(() => toggle.focus());
    };

    const openSearch = () => {
      if (!desktopFoldoutMedia.matches) return;
      header.classList.add('header--search-open');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', toggle.dataset.closeLabel);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => searchInput?.focus({ preventScroll: true }));
      });
    };

    toggle.addEventListener('click', (event) => {
      if (!desktopFoldoutMedia.matches) return;
      event.preventDefault();
      if (header.classList.contains('header--search-open')) {
        closeSearch({ restoreFocus: true });
      } else {
        openSearch();
      }
    });

    document.addEventListener('click', (event) => {
      if (!desktopFoldoutMedia.matches || !header.classList.contains('header--search-open')) return;
      if (dock.contains(event.target)) return;
      closeSearch();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && header.classList.contains('header--search-open')) {
        closeSearch({ restoreFocus: true });
      }
    });

    desktopFoldoutMedia.addEventListener('change', () => {
      if (!desktopFoldoutMedia.matches) {
        closeSearch();
      }
    });
  })();

  (() => {
    const navLabels = [...document.querySelectorAll('[data-header-nav-label]')];
    if (!navLabels.length) return;

    const syncHashNavigationState = () => {
      const currentHash = window.location.hash;
      const contactIsActive = currentHash === '#contact-form';
      const productsAnchorIsActive = currentHash === '#explore-rf-components';

      navLabels.forEach((label) => {
        const isDefaultActive = label.dataset.defaultActive === 'true';
        const isContact = label.dataset.headerNavLabel === 'contact';
        const isProducts = label.dataset.headerNavLabel === 'products';
        let shouldBeActive = isDefaultActive;

        if (contactIsActive) {
          shouldBeActive = isContact;
        } else if (productsAnchorIsActive) {
          shouldBeActive = isProducts;
        }

        label.classList.toggle(
          'header__active-menu-item',
          shouldBeActive
        );
      });
    };

    window.addEventListener('hashchange', syncHashNavigationState);
    window.addEventListener('pageshow', syncHashNavigationState);
    syncHashNavigationState();
  })();

  } catch(e) { console.error(e); }
})();
})();
